import React from 'react';
import {Text, TouchableOpacity, View} from 'react-native';
import {useNavigation} from '@react-navigation/native';

import {EDGE365CHALLENGESCREEN} from '/enum/popover.enum';

import {styles} from './Edge365Card.style';

type Edge365CardProps = {
  latestStreakData: number;
  highestStreakData: number;
  coachId: string;
};

const Edge365Card: React.FC<Edge365CardProps> = ({
  latestStreakData,
  coachId,
  highestStreakData,
}) => {
  const {navigate} = useNavigation();
  const onViewDetails = () => {
    navigate('card', {
      modalName: EDGE365CHALLENGESCREEN,
      coachId,
    });
  };
  return (
    <View style={styles.container}>
      <Text allowFontScaling maxFontSizeMultiplier={2} style={styles.title}>
        EDGE30
      </Text>
      <View style={styles.card}>
        <View style={styles.textContainer}>
          <Text allowFontScaling maxFontSizeMultiplier={2}>
            Current Streak:{' '}
            <Text
              allowFontScaling
              maxFontSizeMultiplier={2}
              style={styles.highlight}>
              {latestStreakData} Days
            </Text>
          </Text>
          <Text
            allowFontScaling
            maxFontSizeMultiplier={2}
            style={styles.highestStreak}>
            Highest Streak:{' '}
            <Text
              allowFontScaling
              maxFontSizeMultiplier={2}
              style={styles.normallight}>
              {highestStreakData} Days
            </Text>
          </Text>
        </View>
        <TouchableOpacity
          style={styles.actionButton}
          onPress={onViewDetails}
          accessibilityRole="button"
          accessibilityLabel="View edge details">
          <Text allowFontScaling maxFontSizeMultiplier={2} style={styles.link}>
            View Details →
          </Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default Edge365Card;
